import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { getCheckinResponse, getTextLink, getTextNoLink } from "../../utils/functions";
import Popup from "../common/Popup";
import Input from "../common/Input";
import PrivacyPreferences from "../PrivacyPreferences";
import ButtonNext from "../ButtonNext";

const Step4 = ({
  checkinData,
  bookingData,
  setBookingData,
  privacyPreferences,
  setPrivacyPreferences,
  onComplete
}) => {
  const { t } = useTranslation();

  const [showPopup, setShowPopup] = useState(false);
  const [privacyPolicy, setPrivacyPolicy] = useState(false);
  const [showPrivacyPreferences, setShowPrivacyPreferences] = useState(false);
  const [isButtonNextDisabled, setIsButtonNextDisabled] = useState(false);

  const handleChange = (field, value) => {
    setBookingData((prevData) => ({
      ...prevData,
      [field]: value
    }));
  };

  const handleNextStep = async (e) => {
    e.preventDefault();
    setIsButtonNextDisabled(true);
    setShowPopup(false);

    const res = await getCheckinResponse(checkinData);
    setIsButtonNextDisabled(false);

    if (!res) {
      setShowPopup(true);
      return;
    }
    else if (res.redirect) {
      return window.location.href = res.redirect;
    }
    onComplete && onComplete();
  };

  useEffect(() => {
    setIsButtonNextDisabled(!privacyPolicy);
  }, [privacyPolicy]);

  return (
    <form className="step step--4" onSubmit={handleNextStep}>
      <Popup
        status="error"
        showPopup={showPopup}
        message={t("step4.errorSendData")}
        onClose={() => setShowPopup(false)}
      />
      <div className="step__content">
        <Input
          type="textarea"
          name="notes"
          label={t("step4.notes")}
          placeholder={t("step4.notes")}
          value={bookingData.notes}
          onChange={handleChange}
        />
        <Input
          type="checkbox"
          name="privacyPolicy"
          label={t("step4.privacyPolicy")}
          value={privacyPolicy}
          onChange={(field, value) => setPrivacyPolicy(value)}
        />

        <p className="step__privacy">
          {getTextNoLink(t("privacy.description"))[0]}
          <button type="button" onClick={() => setShowPrivacyPreferences(true)}>
            {getTextLink(t("privacy.description"))}
          </button>
          {getTextNoLink(t("privacy.description"))[1]}
        </p>

        {showPrivacyPreferences && (
          <PrivacyPreferences
            preferences={privacyPreferences}
            setPreferences={setPrivacyPreferences}
            onClose={() => setShowPrivacyPreferences(false)}
            onClickOutside={() => setShowPrivacyPreferences(false)}
          />
        )}
      </div>

      <ButtonNext disabled={isButtonNextDisabled} />
    </form>
  );
};

export default Step4;